
const breakpointValue = (mixed, windowWidth) => {
  const valueAsNum = parseInt(mixed);

  if (valueAsNum > -1) {
    return mixed;
  } else if (typeof mixed !== 'object') {
    return 0;
  }

  let matchedBreakpoint = Infinity;
  let matchedValue = mixed.default || 0;

  for (let k in mixed) {
    const breakpoint = parseInt(k);
    const breakpointValRaw = mixed[breakpoint];
    const breakpointVal = parseInt(breakpointValRaw);

    if (isNaN(breakpoint) || isNaN(breakpointVal)) {
      continue;
    }

    const isNewBreakpoint =
      windowWidth <= breakpoint && breakpoint < matchedBreakpoint;

    if (isNewBreakpoint) {
      matchedBreakpoint = breakpoint;
      matchedValue = breakpointValRaw;
    }
  }

  return matchedValue;
};

export default {
  name: 'AppGrid',
  props: {
    cols: {
      type: [Object, Number, String],
      default: 2
    },
    gutter: {
      type: [Object, Number, String],
      default: 0
    },
    rowGap: { type: Number, default: 32 },
    minCardWidth: { type: Number, default: 0 }
  },
  data() {
    return {
      displayColumns: 2,
      displayGutter: 0
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.reCalculate();
    });

    if (window) {
      window.addEventListener('resize', this.reCalculate);
    }
  },

  updated() {
    this.$nextTick(() => {
      this.reCalculate();
    });
  },

  beforeDestroy() {
    if (window) {
      window.removeEventListener('resize', this.reCalculate);
    }
  },

  methods: {
    reCalculate() {
      const previousWindowWidth = this.windowWidth;

      this.windowWidth = (window ? window.innerWidth : null) || Infinity;

      if (previousWindowWidth === this.windowWidth) {
        return;
      }

      this._reCalculateColumnCount(this.windowWidth);

      this._reCalculateGutterSize(this.windowWidth);
    },

    _reCalculateGutterSize(windowWidth) {
      this.displayGutter = breakpointValue(this.gutter, windowWidth);
    },

    _reCalculateColumnCount(windowWidth) {
      let newColumns = breakpointValue(this.cols, windowWidth);

      newColumns = Math.max(1, Number(newColumns) || 0);

      this.displayColumns = newColumns;
    },

    _getChildItemsInRowsArray() {
      const rows = [];
      let childItems = this.$slots.default || [];

      if (
        childItems.length === 1 &&
        childItems[0].componentOptions &&
        childItems[0].componentOptions.tag === 'transition-group'
      ) {
        childItems = childItems[0].componentOptions.children;
      }

      for (
        let i = 0, visibleItemI = 0;
        i < childItems.length;
        i++, visibleItemI++
      ) {
        if (!childItems[i].tag) {
          visibleItemI--;

          continue;
        }

        const rowIndex = Math.floor(visibleItemI / this.displayColumns);

        if (!rows[rowIndex]) {
          rows[rowIndex] = [];
        }

        if (childItems[i].elm) {
          childItems[i].elm.style.flex = 1;
        }

        rows[rowIndex].push(childItems[i]);
      }

      return rows;
    }
  },
  render(createElement) {
    const rowsContainingChildren = this._getChildItemsInRowsArray();
    const isGutterSizeUnitless =
      parseInt(this.displayGutter) === this.displayGutter * 1;
    const gutterSizeWithUnit = isGutterSizeUnitless
      ? `${this.displayGutter}px`
      : this.displayGutter;

    const rowStyle = {
      display: 'grid',
      border: '0 solid transparent',
      gridTemplateColumns: `minmax(${this.minCardWidth}px,1fr)`.repeat(
        this.displayColumns
      ),
      gridColumnGap: gutterSizeWithUnit,
      overflowX: this.minCardWidth > 0 ? 'auto' : 'visible'
    };

    const rows = rowsContainingChildren.map((children, index) => {
      return createElement(
        'div',
        {
          key: index + '-' + rowsContainingChildren.length,
          style: {
            ...rowStyle,
            marginTop: index === 0 ? 0 : `${this.rowGap}px`
          }
        },
        children
      );
    });
    return createElement('div', null, rows);
  }
};
